import React from 'react';
import HeroContent from './HeroContent';
import HeroVisual from './HeroVisual';
import VideoSection from './VideoSection';

const Hero: React.FC = () => {
  return (
    <>
      <section className="relative py-20 lg:py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <HeroContent />
            <HeroVisual />
          </div>
        </div>
      </section>
      <VideoSection />
    </>
  );
};

export default Hero;